import { useUsers } from './useUsers';

export const useUserSuggestions = () => {
  const { users } = useUsers();

  const suggestions = users.map(user => ({
    email: user.email,
    name: user.fullName,
    avatarUri: user.pictureUri ?? undefined,
  }));

  return { users, suggestions };
};
